import { defineMessages } from 'react-intl';

export const i18n: {
	salesforceStageFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	salesforceStageFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	salesforceStageFilterLabel: {
		id: 'search-page.salesforce.filter.stage',
		defaultMessage: 'Deal stage',
		description:
			'Label for the Salesforce filter that narrows search results by the stage of a Salesforce Deal (opportunity).',
	},
	salesforceStageFilterNoOptions: {
		id: 'search-page.salesforce.filter.stage.no-options',
		defaultMessage: 'No stages available',
		description:
			'Message shown in the Salesforce stage filter dropdown when no stage options are available',
	},
});
